import styled from 'styled-components';
const S = {};

S.BetHistoryItemDetails = styled.div`

`;

S.BetHistoryDetailsHeader = styled.div`
    
`;

S.BetHistoryDetailsBody = styled.div`
    
`;

S.BetHistoryDetailsWrapper = styled.div``;

export default S;